import React, { useContext, useState, useEffect } from "react";
import eventFeedback from "../../contexts/eventFeedback";
import { io } from "socket.io-client";
import { useApi } from "../../hooks/useApi";
import stateToggler from "../../helpers/stateToggler";
import "../../assets/css/test-global-websocket/test-global-websocket.css";


const GlobalWebsocket = ({}) => {
    const { fetchGet, fetchPost } = useApi();

    const {queueMessage} = useContext(eventFeedback);
    // holds an initialized socketio connection object
    const [globalSocket, setGlobalSocket] = useState(false);
    // switches listening socket error/success
    const [socketSwitch, setSocketSwitch] = useState(true);
    // opens the socket window
    const [socketOpen, setSocketOpen] = useState(false);
    // value of input
    const [saveValue, setSaveValue] = useState("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut congue ac neque a ultrices. Pellentesque at fermentum odio, et venenatis lacus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Sed in leo non erat pulvinar viverra. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae.");
    // mole
    const [moleActive, setMoleActive] = useState(false);

    useEffect(() => {
        try{
            setGlobalSocket(io(``));
        }
        catch{
            console.log("failed to initialize websocket connector.");
        }
    }, [])

    // sets up global sockets for error/success themed messages
    useEffect(() => {
        // if global socket is initialized
        if(globalSocket){            
            // sets both error and success themed connections
            globalSocket.on("global-test-1", (data) => {
                // console.log(socketSwitch);
                if(socketSwitch){
                    queueMessage({message: data.message, type: "success"});
                }
            });
    
            globalSocket.on("global-test-2", (data) => {
                // console.log(socketSwitch);
                if(!socketSwitch){
                    queueMessage({message: data.message, type: "error"});
                }
            });
        }

        return () => {
            if(globalSocket){
                // destroy connections if the socketswitch dependency changes to refresh its value in the globalsocket connection closure
                // should seldom happen in production environment. It happens here frequently though for proof of concept
                globalSocket.removeAllListeners();
            }
        }
    }, [globalSocket, socketSwitch]);

    const onGlobalOneClick = (e) => {
        const message = document.getElementById("relayText").value;

        fetchPost(`/routes/api/websocket/message1`, {message: message});
        // fetch(`/routes/api/websocket/message1`, {
        //     method: "POST",
        //     headers: {
        //         Accept: "application/json",
        //         "Content-Type": "application/json"
        //     },
        //     body: JSON.stringify({message: message})
        // });
    };

    const onGlobalTwoClick = (e) => {
        const message = document.getElementById("relayText").value;

        fetchPost(`/routes/api/websocket/message2`, {message: message});

        // fetch(`/routes/api/websocket/message2`, {
        //     method: "POST",
        //     headers: {
        //         Accept: "application/json",
        //         "Content-Type": "application/json"
        //     },
        //     body: JSON.stringify({message: message})
        // });
    };

    return(
        <div className={"globalWebsocketContainer " + (moleActive ? "moleActive" : "")}>
            <svg id="Layer_1" alt="mole" title="mole" className={"mole " + (moleActive ? "moleActive " : "") + (socketOpen ? "moleSocket" : "")} onClick={() => setMoleActive(prev => !prev)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 395 263"><title>{moleActive ? "Molus Minimus" : "Molus Maximus" }</title><path style={{fill: "currentcolor"}}  d="M256.63,144.6c-33.69,4.53-92.63,7.73-126.67,0,11.76-7.97,9.89-21.4,9.89-21.4V56.87l8.9-5.67h87.47l8.92,6.08,1.03,67.53s-1.84,11.36,10.46,19.8Z" fill="#231f20"/><path style={{fill: "currentcolor"}}  d="M246.96,36.2c-13.57,23.01-24.09,36.2-53.81,36.2s-40.51-12.38-53.81-36.2C149.84,7.34,163.44,0,193.16,0s43.75,5.18,53.81,36.2Z" fill="#231f20"/><ellipse style={{fill: "currentcolor", filter: "invert(100%)"}}  cx="174.23" cy="30.03" rx="4.87" ry="4.86" fill="#fff"/><ellipse style={{fill: "currentcolor", filter: "invert(100%)"}}  cx="212.08" cy="30.03" rx="4.87" ry="4.86" fill="#fff"/><path style={{fill: "currentcolor", filter: "invert(100%)"}}  d="M200.25,59.04c1.44,3.6-3.15,7.02-7.03,7.02s-8.26-3.34-7.03-7.02,3.15-4.03,7.03-4.03,5.61.46,7.03,4.03Z" fill="#fff"/><line style={{stroke: "currentcolor", filter: "invert(100%)"}}  x1="199.3" y1="59.74" x2="205.17" y2="40.58" fill="none" stroke="#fff" stroke-miterlimit="10"/><line style={{stroke: "currentcolor", filter: "invert(100%)"}}  x1="187.01" y1="59.6" x2="181.14" y2="40.44" fill="none" stroke="#fff" stroke-miterlimit="10"/><path style={{fill: "currentcolor"}}  d="M192.16,62.68c0,.62-1.23,1.12-2.75,1.12s-2.75-.5-2.75-1.12,1.11-1.12,2.75-1.12c1.52,0,2.75.5,2.75,1.12Z" fill="#231f20"/><ellipse style={{fill: "currentcolor"}}  cx="197.5" cy="62.68" rx="2.75" ry="1.12" fill="#231f20"/><path style={{fill: "currentcolor"}}  d="M140.7,57.11s-5.04-9.41-7.57-16.75c-23.79,2.7-64.76,29.36-70.57,45.12,10.54,1.08,17.3-5.67,25.15-4.59-14.47,7.08-12.98,4.59-24.6,18.64-6.62,13.64,7.03-4.19,24.06,0-9.43,5.69-6.76,1.35-20.28,16.21-7.17,14.72,7.44-2.7,25.15-4.32-6.85,7.14-7.29,5.35-15.68,17.02-3.51,12.56,4.9-.14,24.69-5.4-4.69,6.12-2.9,3.05-13.6,15.4,4.6,2.7,29.47-6.21,33.53-14.59,5.94-9.46,7.98-6.48,12.44-34.04,4.46-27.56,7.3-32.69,7.3-32.69Z" fill="#231f20"/><path style={{fill: "currentcolor"}}  d="M244.17,57.11s5.04-9.41,7.57-16.75c23.79,2.7,64.76,29.36,70.57,45.12-10.54,1.08-17.3-5.67-25.15-4.59,14.47,7.08,12.98,4.59,24.6,18.64,6.62,13.64-7.03-4.19-24.06,0,9.43,5.69,6.76,1.35,20.28,16.21,7.17,14.72-7.44-2.7-25.15-4.32,6.85,7.14,7.29,5.35,15.68,17.02,3.51,12.56-4.9-.14-24.69-5.4,4.69,6.12,2.9,3.05,13.6,15.4-4.6,2.7-29.47-6.21-33.53-14.59-5.94-9.46-7.98-6.48-12.44-34.04s-7.3-32.69-7.3-32.69Z" fill="#231f20"/><polygon style={{fill: "currentcolor"}} points="251.44 91.95 244.16 101.04 242.16 58.35 252.44 58.35 251.44 91.95" fill="#231f20"/><polygon style={{fill: "currentcolor"}} points="132.84 90.6 140.12 99.69 142.12 57.01 131.84 57.01 132.84 90.6" fill="#231f20"/><path style={{fill: "currentcolor"}}  d="M.05,250.82s5.14,3.51,15.95,2.97,30.28-1.78,36.23.06c5.95,1.83,42.31,6.83,45.97,7.24,3.65.41,65.3,2.43,76.52,1.35,11.22-1.08,15.41,1.3,32.45.31,17.03-.99,71.38.9,78.41-2.2s4.06-1.06,14.06-3.64,17.57.67,24.6-3.39,26.63-1.22,26.63-1.22c0,0,30.82-1.62,44.13-2.43-4.6-6.99-4.66-10.54-9.25-11.89-3.11-5.81-10.95-3.65-15.68-13.51-3.26-3.54-8.11,1.35-7.84-8.92-3.24-10.54-11.36-3.65-15.41-7.83s1.08-1.62-4.33-7.56c0-7.83,3.11-2.43-6.22-9.19-9.33-6.75-10.14-3.24-11.9-15.94-1.76-12.7-12.17-15.13-12.17-15.13,0,0-6.08,3.51-8.11,1.62-2.03-1.89,5.36,1.37-13.56-2.96s-11.09-.69-18.39-7.04c-7.3-6.35-12.97-5.04-14.52-3.95-4.44,3.11-108.39,10.24-129.67-1-3.11,6.35-4.19-2.75-26.9-.05-4.23,1.96-11.53,12.82-15.61,17.43-6.49-3.38-17.53,15.8-19.83,17.56s-14.87,15.8-26.5,21.34c.81,6.89-10.27,9.86-11.36,12.16-2.03-.81-.27,9.19-.27,9.19,0,0-28.8,3.92-27.44,26.61Z" fill="#231f20"/><path style={{fill: "currentcolor", filter: "invert(100%)"}}  d="M260.69,146.71c-18.53,7.48-128.84,7.93-132.73-.12-.31-.64,2-2,2-2h126.67s5.12,1.69,4.06,2.12Z" fill="#fff"/><path style={{fill: "currentcolor"}}  d="M256.63,144.6c-18.53,7.48-122.78,8.05-126.67,0-.31-.64,2.03-1.2,2.03-1.2h123.02s2.69.77,1.63,1.2Z" fill="#231f20"/></svg>
            <div className={"globalWebsocketWrapper " + (moleActive ? "moleActive" : "")}>
                <button style={{fontFamily: "monospace", cursor: "pointer", display: "block"}} type="button" onClick={() => stateToggler(socketOpen, setSocketOpen) } >{socketOpen ? "Contract Socket Section" : "Expand Socket Section" }</button>
                {socketOpen &&
                    <>
                        {/* <br /> */}
                        <br />
                        <div style={{fontFamily: "monospace", backgroundColor: "var(--offWhite)", width: "fit-content", padding: "var(--spacing-half)", display: "block"}}>
                            Socket: { socketSwitch ? "global-socket-1 (success)" : "global-socket-2 (error)" }
                            <br />
                            <button style={{fontFamily: "monospace", marginTop: "calc(var(--spacing-half) * .5)"}} type="button" onClick={(e) => stateToggler(socketSwitch, setSocketSwitch)} >Change Socket</button>
                            <br />
                            <br />
                            <label htmlFor="relayText">Message: </label>
                            <input id="relayText" name="relayText" type="text" onChange={(e) => setSaveValue(e.target.value)} value={saveValue} />
                            <br />
                            <button style={{fontFamily: "monospace", marginTop: "var(--spacing-half)"}} type="button" onClick={onGlobalOneClick} >Relay to: Global 1</button>
                            <br />
                            <button style={{fontFamily: "monospace", marginTop: "var(--spacing-half)"}} type="button" onClick={onGlobalTwoClick} >Relay to: Global 2</button>
                        </div>
                    </>
                }

                
                {/* <div className="flex flexColumn flexCenter" style={{width: "fit-content"}}>
                    <div style={{marginTop: "var(--spacing-half)", marginRight: "var(--spacing-half)", color: "var(--offWhite)", fontWeight: 400, display: "inline-block"}}>(True start of page)</div>
                    <i class="fa-solid fa-arrow-down" style={{color: "var(--offWhite)"}}></i>
                </div> */}
            </div>
        </div>
    )
};

export default GlobalWebsocket;